const data = [
    {
        id: 1,
        attraction: "Mount Fuji",
        country: "Japan",
        googleMapsUrl: "https://maps.app.goo.gl/cooy5P2jhsNu7a547",
        startDate: "12 Jan, 2021",
        endDate: "24 Jan, 2021",
        description: "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
        photo:"./imgs/mount_fuji.jpg"
    },
    {
        id: 2,
        attraction: "Sydney Opera House",
        country: "Australia",
        googleMapsUrl: "https://maps.app.goo.gl/hvAUsKCt1xJUz4Pg6",
        startDate: "12 May, 2021",
        endDate: "8 June, 2021",
        description: "The Sydney Opera House is a multi-venue performing arts centre in Sydney. Located on the banks of the Sydney Harbour, it is often regarded as one of the 20th century's most famous and distinctive buildings.",
        photo:"./imgs/sydney_opera_house.jpg"
    },
    {
        id: 3,
        attraction: "Geirangerfjord",
        country: "Norway",
        googleMapsUrl: "https://maps.app.goo.gl/yptRwPTT2AVdB2R76",
        startDate: "01 Oct, 202",
        endDate: "18 Nov, 2021",
        description: "The Geiranger Fjord is a fjord in the Sunnmøre region of Møre og Romsdal county, Norway. It is located entirely in the Stranda Municipality.",
        photo:"./imgs/geirangerfjord.jpg"
    }
]

export default data